/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Category_System_Locked_HintInputs */

const vi_expense_category_system_locked_hint = /** @type {(inputs: Expense_Category_System_Locked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục mặc định — không đổi tên, tắt hoặc xoá được`)
};

/**

* @param {Expense_Category_System_Locked_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_system_locked_hint = /** @type {((inputs?: Expense_Category_System_Locked_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_System_Locked_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_system_locked_hint(inputs)
});